import React from "react";
import { Link } from "react-router-dom";
import { useAtom } from "jotai";
import { loggedInUser } from "../../../utils/store";
import { Button, Card } from "react-bootstrap";
import { MdOutlineArrowForwardIos } from "react-icons/md";
const TeamFunctionCard = ({
  bgColor,
  image,
  title,
  description,
  url,
  teamId,
  userId,
  text,
}) => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);

  return (
    <>
      {/* <Card className="subscriptionCard">
        <Card.Body className="text-center">
          <div className="imgWrapper">
            <div className="coverImg">
              <div style={{ background: bgColor }} className="circle"></div>
            </div>
            <div className="profileImg">{image}</div>
          </div>
          <div class="card-header">
            <div class="card-title h5">{title}</div>
            <p class="d-flex align-items-center justify-content-between">
              {description}
            </p>
          </div>

          <Link
            to={
              teamId && userId
                ? `/team/${teamId}/teamMembers/member/${userId}${url}`
                : url
            }
            className=""
          >
            <Button variant="primary" className="createBtn mt-3 m-auto">
              {text}
            </Button>
          </Link>
        </Card.Body>
      </Card> */}
      <Link
        to={
          teamId && userId
            ? `/team/${teamId}/teamMembers/member/${userId}${url}`
            : url
        }
      >
        <div className="cardWrapper d-flex align-items-center justify-content-between shadow-sm">
          <div className="d-flex align-items-center">
            <div className="imgWrapper">{image}</div>
            <div className="infoWrapper">
              <h3>{title}</h3>
              <p className="mb-0">{description}</p>
            </div>
          </div>

          <MdOutlineArrowForwardIos />
        </div>
      </Link>
    </>
  );
};
export default TeamFunctionCard;
